<template>
  <el-dialog
    title="题目收藏"
    :visible.sync="visible"
    @close="dialogClose"
    width="400px"
    class="changeEditType"
  >
    <el-radio-group v-model="checkCollectDir" class="collect-radio-group">
      <el-radio
        v-for="item in collectList"
        :key="item.dirId"
        :label="item.dirId"
        @change="handleCheckList(item.dirId)"
      >
        {{item.dirName}}
        <el-input
          class="dir-name-input"
          id="dirNameInput"
          v-if="!item.dirName"
          placeholder="新建文件夹"
          style="width: 200px"
          v-model="newDirName"
          @keyup.enter="handleBlurCreateDir"
          @blur="handleBlurCreateDir"
        ></el-input>
      </el-radio>
    </el-radio-group>
    <a
      href="javascript:;"
      v-if="isShowAddDirBtn"
      class="add-collect"
      @click="handleAddNewCollectDir"
    >
      <span>+</span>添加收藏夹
    </a>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="confirmCollect">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { DOMAIN } from "../utils/api";
import { MSG } from "../utils/utils";
import http from "../utils/http";

export default {
  name: "collectDialog",
  data() {
    return {
      interface: {
        collect: `/survey/collect`,
        addDir: `/questionDir/addDir`
      },
      dirNameForm: {
        dirName: ""
      },
      tempDirId: 0,
      newDirName: "",
      isShowAddDirBtn: true,
      visible: false
    };
  },
  props: [
    "dialogShow",
    "showLikeHeart",
    "collectQues",
    "collectList",
    "checkCollectDir"
  ],
  watch: {
    dialogShow: {
      handler(val) {
        this.visible = val;
        if (val) {
          this.isShowAddDirBtn = true;
        }
      }
    }
  },
  methods: {
    handleCheckList(dirId) {
      this.tempDirId = dirId;
    },
    confirmCollect() {
      this.$emit("update:dialogShow", false);
      http
        .post(this.interface.collect, {
          questionJson: JSON.stringify(this.collectQues),
          dirId: this.checkCollectDir
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            MSG.success("收藏成功");
            this.sidebarActive = "2";
            if (!this.showLikeHeart) {
              this.$emit("update:showLikeHeart", true);
              setTimeout(() => {
                this.$emit("update:showLikeHeart", false);
              }, 800);
            }
            this.$emit("update:showLikeHeart", false);
            this.$emit("confirm", 1, this.checkCollectDir);
          } else {
            MSG.error(message);
          }
        });
    },
    handleAddNewCollectDir() {
      this.newDirName = "";
      this.isShowAddDirBtn = false;
      this.$emit("updateCollectList", "push");
      this.$emit("update:checkCollectDir", -1);
      this.$nextTick(() => {
        this.$el.querySelector("#dirNameInput").focus();
      });
    },
    handleBlurCreateDir() {
      this.isShowAddDirBtn = true;
      let dirName = this.newDirName;
      this.$emit("updateCollectList", "pop");
      if (dirName) {
        this._addCollectDir(dirName);
      } else {
        this.$emit("update:checkCollectDir", this.tempDirId);
      }
    },
    _addCollectDir(newDirName) {
      http
        .get(this.interface.addDir, {
          dirName: newDirName
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.dirNameForm.dirName = "";
            this.newDirName = "";
            this.$emit("confirmDir");
          } else {
            MSG.error(message);
          }
        });
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    }
  }
};
</script>


<style lang="scss" scoped>
.dir-name-input input {
  height: 30px;
  line-height: 14px;
  font-size: 14px;
  padding: 8px;
}
.add-collect {
  color: #ff552e;
  display: block;
  margin-left: 40px;
  span {
    margin-right: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/collectDialog.vue